const getAjaxJson = [
/*    {
        id: 1,
        class: 'example-style1',
        title: '三江源国家大数据基地体验之旅',
        date: '2019/3',
        image: './images/index/example/1.png',
        mobimage: './images/index/mob/example/1.png',
        link: '/detail/1'
    },
    {
        id: 2,
        class: 'example-style2',
        title: '中网直销票务平台体验优化',
        date: '2019/8',
        image: './images/index/example/2.png',
        mobimage: './images/index/mob/example/2.png',
        link: '/detail/2'
    },
    {
        id: 3,
        class: 'example-style2',
        title: '中网观众会员服务及管理体系',
        date: '2018/8',
        image: './images/index/example/3.png',
        mobimage: './images/index/mob/example/3.png',
        link: '/detail/3'
    },
    {
        id: 4,
        class: 'example-style1',
        title: '体育赛事/活动会议/文娱演出的数字化运营平台',
        date: '2019/10',
        image: './images/index/example/4.png',
        mobimage: './images/index/mob/example/4.png',
        link: '/detail/4'
    },
    {
        id: 5,
        class: 'example-style1',
        title: 'AI 人脸识别验检服务',
        date: '2019/5',
        image: './images/index/example/5.png',
        mobimage: './images/index/mob/example/5.png',
        link: '/detail/5'
    }, */
    {
        id: 6,
        class: 'example-style1',
        title: '职场数字化互动体验提升',
        date: '2021/8',
        image: './images/index/example/6.png',
        mobimage: './images/index/mob/example/6.png',
        link: '/detail/6'
    },
    {
        id: 7,
        class: 'example-style2',
        title: '金融科技数字化体验创新',
        date: '2021/12',
        image: './images/index/example/7.png',
        mobimage: './images/index/mob/example/7.png',
        link: '/detail/7'
    },
    {
        id: 8,
        class: 'example-style2',
        title: '运营指挥系统数字化体验提升',
        date: '2021/11',
        image: './images/index/example/8.png',
        mobimage: './images/index/mob/example/8.png',
        link: '/detail/8'
    },
    {
        id: 9,
        class: 'example-style1',
        title: '数字化演播厅创新设计',
        date: '2021/10',
        image: './images/index/example/9.png',
        mobimage: './images/index/mob/example/9.png',
        link: '/detail/9'
    }

];

const indexJson = {
    getAjaxJson
};

export default indexJson

